import { DDSTypography } from 'den-design-system'
import React from 'react'
import UsageBar from './UsageBar'
import arrowRightIcon from '../../assets/icons/arrowRight.svg'
import pallete from '../../global/newPallete'
import { replaceUrl } from '../../utils/UrlUtils'
import { useNavigate } from 'react-router-dom'
import { useStoreContext } from '../../store/StoreContext'

interface AbsoluteUsageWithTitle {
  title: string
  value: number
}

interface SFUsageCardProps {
  title: string
  usage: number
  requests: AbsoluteUsageWithTitle
  limit: AbsoluteUsageWithTitle
  link?: string
}

const SFUsageCard: React.FC<SFUsageCardProps> = ({
  title,
  usage,
  requests,
  limit,
  link
}) => {
  const navigate = useNavigate()
  const { scopeStore } = useStoreContext()
  const handleNavigation = (link: string) => {
    navigate(
      replaceUrl(
        link,
        scopeStore.getScope()['organization-id'] as string,
        scopeStore.getScope()['project-id'] as string,
        scopeStore.getScope()['environment-id'] as string
      )
    )
  }
  return (
    <div
      style={{
        borderColor: pallete.colors.stroke2,
        borderRadius: '8px'
      }}
      className='w-full max-w-xs min-h-[200px] border p-[16px] space-y-[12px] shadow-sm bg-white flex flex-col'
    >
      <div
        className='flex items-start cursor-pointer justify-between'
        onClick={() => link && handleNavigation(link)}
      >
        <DDSTypography.Title
          type='h5'
          variant='semiBold'
          color={pallete.colors.textDark4}
          style={{
            wordBreak: 'break-word',
            hyphens: 'auto'
          }}
        >
          {title}
        </DDSTypography.Title>

        <img
          src={arrowRightIcon}
          alt='Arrow'
          className='h-[16px] cursor-pointer'
          onClick={() => link && handleNavigation(link)}
        />
      </div>

      <div>
        <DDSTypography.Title
          type='h4'
          variant='semiBold'
          color={pallete.colors.primary2}
        >
          {isNaN(usage) || !isFinite(usage) ? '-' : usage + '%'}
        </DDSTypography.Title>
      </div>

      <div className='w-full h-[12px] rounded-full overflow-hidden'>
        <UsageBar usage={usage} />
      </div>

      <div className='flex-grow flex flex-col justify-end space-y-[8px]'>
        <div>
          <DDSTypography.Title
            type='h5'
            variant='medium'
            color={pallete.colors.black}
            style={{
              wordBreak: 'break-word'
            }}
          >
            {requests.title}
          </DDSTypography.Title>
        </div>
        <div>
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.textDark3}
          >
            {`${requests.value === -1 ? '-' : requests?.value?.toLocaleString('en-US')} / ${
              limit?.value === -1 ? '-' : limit?.value?.toLocaleString('en-US')
            }`}
          </DDSTypography.Title>
        </div>
      </div>
    </div>
  )
}

export default SFUsageCard
